import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { API_URL } from "@/core/config";

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = API_URL;
        Vue.axios.defaults.headers.common['Authorization'] = 'Bearer 26|3jQrvPh362E83gQomuWvN0KOfGPei0scnY0OaZMq';
    },
    get(resource, slug = "") {
        return Vue.axios.get(`${resource}${slug}`).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },
    post(resource, params) {
        return Vue.axios.post(`${resource}`, params);
    }
};

export default ApiService;

export const SubmitFormService = {
    post(params) {
        return ApiService.post('sellers/submit', params);
    }
};

export const FortnoxService = {
    post(params) {
        return ApiService.post('fortnox/companyinformation', params);
    }
};
